<template>
    <div class="flex gap-x-6 items-baseline">
        <i
            class="text-xl n-color-text-weak relative top-2"
            :class="iconType + ' ' + icon"
        ></i>
        <div class="n-color-text">
            <h5 class="font-bold">{{ title }}</h5>
            <slot></slot>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            default: ''
        },

        iconType: {
            type: String,
            default: 'far' // regular
        }
    }
};
</script>
